module.exports = __webpack_public_path__ + "img/get_wx.f813cc9c.png";